module.exports = __webpack_public_path__ + "static/media/boy_thinking.0ac1eb59.gif";